import { fromJS } from 'immutable';

import validateFieldsByRules from '../validate/ruleValidator';
import matchesRegexRule from '../validate/matchesRegexRule';
import getGDPRFieldConstraints from '../validate/validateGDPRTermsConsentGiven';
import getCardholderAgreementFieldConstraints from '../validate/validateCardholderAgreement';
import loyaltyMessages from '../loyalty/loyaltyMessages';
import { LOYALTY_FIELD } from '../loyalty/loyaltyModule';


export const loyaltyNumberConstraints = regExp => fromJS({
    [LOYALTY_FIELD]: [
        matchesRegexRule(loyaltyMessages.invalidLoyaltyNumber, regExp)
    ]
});

const validate = (values, props) => {
    const {
        loyaltyValidationRegex, isGdprTermsAcknowledgementEnabled, gdprTermsAcknowledgementFormat,
        isCardholderAgreementEnabled, cardholderAgreementFormat, intl
    } = props;

    const combinedConstraints = loyaltyNumberConstraints(loyaltyValidationRegex)
        .merge(getCardholderAgreementFieldConstraints(isCardholderAgreementEnabled, cardholderAgreementFormat))
        .merge(getGDPRFieldConstraints(isGdprTermsAcknowledgementEnabled, gdprTermsAcknowledgementFormat));
    return validateFieldsByRules(values, combinedConstraints, intl);
};

export default validate;
